import React from "react";
import {Box, Typography, useMediaQuery} from "@mui/material";
// import {ReactComponent as FlyerIcon} from "../../assets/flyer_image_icon_.svg";
import flyerIcon from "../../assets/flyer_image_icon_.png"
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {makeStyles} from "@mui/styles";
import {useParams} from "react-router-dom";
import {flipbookEditorUrlDto} from "../../dtos";

const useStyles = makeStyles(() => ({
    selfServiceSidePanel: {
        width: `100%`,
        height: `100%`,
        backgroundColor: `#F0F3FD`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        padding: `10px`,
        // [theme.breakpoints.down('sm')]: {
        //     backgroundColor: `#ffffff`
        // }
    }
}))


export const SidePanel = () => {
    const flyersState = useTypedSelector((state) => state.flyers);
    const {flyerId} = useParams<flipbookEditorUrlDto>();
    const isSm = useMediaQuery(`(max-width:899px)`);
    const properties = {
        isSm: isSm
    };
    const classes = useStyles(properties);
    let text = flyersState.flyers.length ? `Click to open a flyer
or create a new one for free!` : `You have no active flyers yet, 
click New Flyer to create one for free`;
    if(flyerId){
        if(flyerId === '-1'){
            text = `Create New Publication`;
        } else {
            text = `Edit Publication`;
        }
    }
    return (
        <Box className={classes.selfServiceSidePanel}>
            <Box>
                <Box sx={{display: `flex`, alignItems: `center`, justifyContent: `center`}}>
                    <img src={flyerIcon} alt=""/>
                </Box>
                <Typography sx={{
                    fontFamily: 'roboto',
                    fontStyle: `normal`,
                    fontWeight: `500`,
                    fontSize: `28px`,
                    lineHeight: `42px`,
                    textAlign: `center`
                }}>
                    Welcome to
                </Typography>
                <Typography sx={{
                    fontFamily: 'roboto',
                    fontStyle: `normal`,
                    fontWeight: `500`,
                    fontSize: `28px`,
                    lineHeight: `42px`,
                    textAlign: `center`
                }}>
                    XC Flyers Editor
                </Typography>
                <Typography sx={{
                    fontFamily: 'roboto',
                    fontStyle: `normal`,
                    fontWeight: `400`,
                    fontSize: `20px`,
                    lineHeight: `30px`,
                    marginTop: `14px`,
                    textAlign: `center`,
                    whiteSpace: `pre-wrap`
                }}>
                    {
                        text
                    }
                </Typography>
            </Box>
        </Box>
    )
}